<p>
  addnewaction works!
</p>
